import React  from 'react';
import StoryPointsComponentProto from './story-points-proto';

export default function renderListInView(props) {
    return <StoryPointsComponentProto renderMode="view" {...props} />;
}